import gql from 'graphql-tag'

export const GET_OVERVIEW = gql`
query(
    $dateOne:Date
    $datetwo:Date
  ){
    overView(dateOne:$dateOne datetwo:$datetwo){
      opening
      hiringEmp
      newGradApprove
      newGradPending
      totalCVApproved
      totalCVPending
      saveJob{
        _id
          title
          isSave
          industry
          workingLocation
      }
      applyJob{
         _id
          title
          applyStatistics
          industry
          workingLocation
      }
      viewJob{
         _id
          title
          isClick
          industry
          workingLocation
      }
      shareJob{
         _id
          title
          isShare
          industry
          workingLocation
      }
    }
  }
  

`